// Debounce function to limit the rate at which a function can fire
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  window.addEventListener('DOMContentLoaded', function () {
    setEqualHeight('.shopBySkinConcern__content');
  
    // Debounced resize event listener
    window.addEventListener('resize', debounce(function () {
      setEqualHeight('.shopBySkinConcern__content');
    }, 250)); // 250ms debounce time
  });
  
  function setEqualHeight(selector) {
    var elements = document.querySelectorAll(selector);
    var maxHeight = 0;
  
    elements.forEach(function (element) {
      element.style.height = 'auto'; // Reset height to auto before calculating new height
      var height = element.clientHeight;
      maxHeight = Math.max(maxHeight, height);
    });
  
    elements.forEach(function (element) {
      element.style.height = maxHeight + 'px';
    });
  }


// Define the Splide configuration object
const splideConfigShopByConcern = {
  perPage: 4,
  perMove: 1,
  gap: '32px',
  pagination: false,
  arrows: false,
  updateOnMove: true,
  breakpoints: {
    1120: {
      perPage: 2,
      perMove: 1,
      gap: '32px',
      padding: { right: '12.4rem' },
    },
    767: {
      perPage: 1,
      perMove: 1,
      gap: '20px',
      padding: { right: '20%' },
    },
    430: {
      perPage: 1,
      perMove: 1,
      gap: '20px',
      padding: { right: '30%' },
    },
  },
};

// Function to initialize Splide
function initSplide() {
  // Destroy existing Splide instance if it exists
  const existingSlider = document.querySelector('#shopByConcern.splide');
  if (existingSlider && existingSlider.splide) {
    existingSlider.splide.destroy();
  }

  // Select the slider element
  const sliderElement = document.querySelector('#shopByConcern');
  
  // Only initialize if the slider element exists
  if (sliderElement) {
    const splide = new Splide(sliderElement, splideConfigShopByConcern);
    
    // Add overflow event handler
    splide.on('overflow', function(isOverflow) {
      const options = {
        arrows: isOverflow,
        pagination: isOverflow,
        drag: isOverflow
      };
      
      // Update the slider options
      splide.options = {...splide.options, ...options};
      
      // Refresh the slider to apply changes
      if (splide.initialized) {
        splide.refresh();
      }
    });
    
    splide.mount();
  }
}

// Use a single event listener with a flag to prevent multiple initializations
let splideInitialized = false;

document.addEventListener('DOMContentLoaded', function() {
  if (!splideInitialized) {
    initSplide();
    splideInitialized = true;
  }
});

document.addEventListener('shopify:section:load', function() {
  initSplide();
});